import axios from 'axios';
import { API_BASE_URL } from '../../config';

const workspaceHelpContentApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

function normalizeScene(scene) {
  return scene === 'canvas' ? 'canvas' : 'writing';
}

export async function getWorkspaceHelpContent(scene) {
  let response;
  try {
    response = await workspaceHelpContentApi.get('workspace-help-content/list', {
      params: { scene: normalizeScene(scene) },
    });
  } catch (error) {
    throw new Error(error?.response?.data?.message || '帮助内容加载失败，请稍后重试');
  }
  const payload = response?.data;

  if (Number(payload?.code) !== 200) {
    throw new Error(payload?.message || '帮助内容加载失败');
  }

  const data = payload?.data || {};
  return {
    articles: Array.isArray(data.articles) ? data.articles : [],
    videos: Array.isArray(data.videos) ? data.videos : [],
  };
}
